import "./index.less";
import React from "react";
import { Modal } from "antd";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import TargetTooltip from "./TargetTooltip";

interface Target {
    selector: string;

    title: React.ReactNode;
}

interface OrderManagementBeginnerGuideModalProps extends InjectBaseModalProps {
    targets: Target[];
}

const OrderManagementBeginnerGuideModal: React.FC<OrderManagementBeginnerGuideModalProps> = function (props) {
    const { open, onCancel, targets } = props;

    return (
        <Modal
            className="ec-order-management-beginner-guide-modal"
            open={open}
            onCancel={onCancel}
            footer={null}
            closable={false}
            mask={{ closable: true }}
            transitionName="ant-fade"
        >
            {targets.map((it, index) => {
                return <TargetTooltip selector={it.selector} title={it.title} key={index} />;
            })}
        </Modal>
    );
};

export default React.memo(OrderManagementBeginnerGuideModal);
